import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminDashboardRoutes: RouteObject[] = [
  {
    path: 'admin/dashboard',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_DASHBOARD, title: 'Tableau de bord' },
  },
];
